import { render, staticRenderFns } from "./contact-info-edit-tab.vue?vue&type=template&id=6421424b&scoped=true"
import script from "./contact-info-edit-tab.vue?vue&type=script&lang=js"
export * from "./contact-info-edit-tab.vue?vue&type=script&lang=js"
import style0 from "./contact-info-edit-tab.vue?vue&type=style&index=0&id=6421424b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6421424b",
  null
  
)

export default component.exports